import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Signin } from "../../../Controllers/Auth";
import toast from "react-hot-toast";
import Authorization from "../../../Main/authorization";
import Form from "../../../Componets/Form";
import forms from "../../../Data/Forms/Signin/forms";
import { Button } from "antd";
import PeriodSelectionModal from "../PeriodSelectionModal";

const SigninForm = () => {
  let navigate = useNavigate();
  let isAuthenticate = Authorization();

  const [values, setValues] = useState(forms);
  const [showPeriodModal, setShowPeriodModal] = useState(false);
  const [availablePeriods, setAvailablePeriods] = useState([]);
  const [loginToken, setLoginToken] = useState(null);

  const formdata = async (data) => {
    if (data?.status) {
      const signup = await Signin(data?.data);

      if (signup?.status) {
        const { requires_period_selection, available_periods, token } =
          signup?.data;
        localStorage.setItem("user", token);

        if (requires_period_selection && available_periods?.length > 0) {
          setAvailablePeriods(available_periods);
          setShowPeriodModal(true);
          setLoginToken(token);
        } else {
          navigate("/app/dashboard");
          toast.success(signup?.message);
        }
      } else {
        toast?.error(signup?.message);
      }
    }
  };

  const handlePeriodSelected = (newToken) => {
    if (newToken) {
      localStorage.setItem("user", newToken);
    }
    navigate("/app/dashboard");
    toast.success("Login successful!");
  };

  const fetchData = async () => {
    values[0].button = (
      <div>
        <Button
          size="large"
          className="bg-[#6254be] text-medium form-add-button w-full"
          type="primary"
          htmlType="submit"
        >
          Signin
        </Button>
        <div className="pt-3 text-medium text-gray-500 text-center">
          <span>Don't have an account?</span>
          &nbsp;
          <button type="button" onClick={() => navigate("/signup")}>
            <u className="text-[#6254be]">Signup</u>
          </button>
        </div>
      </div>
    );

    setValues([...values]);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="bg-gray-100">
      {isAuthenticate && !showPeriodModal && <Navigate to="/app/dashboard" />}
      <Form form={values} setForm={setValues} formdata={formdata} />

      <PeriodSelectionModal
        visible={showPeriodModal}
        periods={availablePeriods}
        onClose={() => {
          setShowPeriodModal(false);
          navigate("/app/dashboard");
          toast.success("Login successful! Showing all data");
        }}
        onPeriodSelected={handlePeriodSelected}
      />
    </div>
  );
};

export default SigninForm;
